import { NavLink, Link } from "react-router-dom";
import {
  FaBars,
  FaBlog,
  FaBlogger,
  FaBook,
  FaFont,
  FaHome,
  FaListAlt,
  FaLock,
  FaMoneyBill,
  FaToggleOn,
  FaTrashAlt,
  FaUser,
} from "react-icons/fa";
import {
  FaBookMedical,
  FaBookOpen,
  FaFileImage,
  FaRegPlusSquare,
  FaEdit,
} from "react-icons/fa";
import { MdDelete, MdList, MdMessage, MdSubscriptions } from "react-icons/md";
import { BiSearch, BiCog } from "react-icons/bi";
import { BsCartCheck } from "react-icons/bs";
import { useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import { FaEye } from "react-icons/fa6";
import { path } from "framer-motion/client";

const routes = [
  { path: "/admin/", name: "AdminDashboard", icon: <FaHome /> },
  { path: "/admin/getallchapters", name: "GetAllChapters", icon: <FaEye /> },
 {
        path: "/admin/customergetimg",
        name: "Get Hotspot Images",
        icon: <FaFileImage />,
      },
  {
    path: "/admin/repertory",
    name: "Repertory",
    icon: <FaBookMedical />,
  },
  {
    path: "/admin/adminDashboard",
    name: "Add",
    icon: <FaRegPlusSquare />,
    subRoutes: [
      {
        path: "/admin/addchapter",
        name: "AddChapter",
        icon: <FaBookMedical />,
      },
      {
        path: "/admin/addsubchapter",
        name: "AddSubChapter",
        icon: <FaBookOpen />,
      },
      {
      path:"/admin/hotspotimg",
      name:"Add Hotspot Images"
     },
      {
        path: "/admin/addimage",
        name: "AddImage",
        icon: <FaFileImage />,
      },
    ],
  },
  {
  path: "/admin/adminDashboard",
  name: "Blogs",
  icon: <FaBlog />,
  subRoutes: [
    {
      path: "/admin/adminaddblog",
      name: "Add Blog",
      icon: <FaBlogger />,
    },
    {
      path:"/admin/adminroleblogs",
      name:"Your Blogs",
      icon:<FaBlogger/>,
    },
    
    {
      path:"/admin/adminroleresearch",
      name:"Your Research Paper",
    
    },
    {
      path: "/admin/admingetblogs",
      name: "All Blogs",
      icon: <FaListAlt />, // 📋 shows all blogs
    },
    {
      path: "/admin/admineditblog",
      name: "Edit Blog",
      icon: <FaEdit />, // ✏️ edit existing blog
    },
    {
      path: "/admin/admindltblog",
      name: "Delete Blog",
      icon: <FaTrashAlt />, // 🗑️ delete blog
    },
    {
      path: "/admin/adminupdatestatus",
      name: "Update Status",
      icon: <FaToggleOn />, // 🔘 approve/reject blog
    },{
      path:"/admin/updatestsarticle",
      name:"Update Research status",
      icon: <FaToggleOn />,
    },
    {
      path:"/admin/research",
      name:"All Research Papers"
    },
    {
      path: "/admin/adminresearch",
      name: "Add Research Papers",
      icon: <FaBook />, // 📘 research section
    },
  ],
},
  {
    path: "/admin/adminDashboard",
    name: "Update",
    icon: <FaEdit />,
    subRoutes: [
      {
        path: "/admin/updatechapter",
        name: "UpdateChapter",
        icon: <FaBookMedical />,
      },
      {
        path: "/admin/updatesubchapter",
        name: "UpdateSubChapter",
        icon: <FaBookOpen />,
      },
      {
        path: "/admin/updateimage",
        name: "UpdateImage",
        icon: <FaFileImage />,
      },
      {
        path : "/admin/updatehotspotimg",
        name :"UpdateHotspotImage",
        icon: <FaFileImage />,
      },
    ],
  },

  // ✅ New Dropdown for Hotspot & Customer Image
  // {
  //   path: "/admin/adminDashboard",
  //   name: "Hotspot Images",
  //   icon: <FaFileImage />,
  //   subRoutes: [
   
     
  //   ],
  // },
 
  {
    path: "/admin/adminDashboard",
    name: "Delete",
    icon: <MdDelete />,
    subRoutes: [
      {
        path: "/admin/deletechapter",
        name: "DeleteChapter",
        icon: <FaBookMedical />,
      },
      {
        path: "/admin/deletesubchapter",
        name: "DeleteSubChapter",
        icon: <FaBookOpen />,
      },  {
      path:"/admin/admindlt",
      name:"Delete Hotspot"
     },
     
      {
        path: "/admin/deleteimage",
        name: "DeleteImage",
        icon: <FaFileImage />,
      },
    ],
  },

  {
    path: "/admin/getallcustomers",
    name: "GetAllCustomers",
    icon: <FaUser />,
  },
  {
    path: "/admin/tickets",
    name: "GetAllTicekts",
    icon: <MdMessage />,
  },

  {
    path: "/admin/order",
    name: "Order",
    icon: <BsCartCheck />,
  },
  {
    path: "/admin/subscriptions",
    name: "subscription",
    icon: <MdSubscriptions />,
  },
  {
    path: "/admin/packagelist",
    name: "packagelist",
    icon: <MdList />,
  },
  {
    path: "/admin/settings",
    name: "Setting",
    icon: <BiCog />,
    exact: true,
    subRoutes: [
      {
        path: "/settings/profile",
        name: "Profile ",
        icon: <FaUser />,
      },
      {
        path: "/settings/2fa",
        name: "2FA",
        icon: <FaLock />,
      },
      {
        path: "/settings/billing",
        name: "Billing",
        icon: <FaMoneyBill />,
      },
      {
        path: "fonts",
        name: "Fonts",
        icon: <FaFont />,
      },
    ],
  },
];

const filterRoutes = (allRoutes, term) => {
  const q = term.trim().toLowerCase();
  if (!q) return allRoutes;

  return allRoutes.reduce((acc, route) => {
    if (route.subRoutes) {
      const matchingSubRoutes = route.subRoutes.filter((sub) =>
        sub.name.toLowerCase().includes(q)
      );
      if (route.name.toLowerCase().includes(q)) {
        acc.push(route);
      } else if (matchingSubRoutes.length > 0) {
        acc.push({ ...route, subRoutes: matchingSubRoutes });
      }
    } else if (route.name.toLowerCase().includes(q)) {
      acc.push(route);
    }
    return acc;
  }, []);
};

const SideBar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const toggle = () => setIsOpen(!isOpen);

  const filteredRoutes = useMemo(
    () => filterRoutes(routes, searchTerm),
    [searchTerm]
  );

  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>
        
    <div className="main-container">
  <motion.div
    animate={{
      width: isOpen ? "200px" : "45px",
      transition: {
        duration: 0.5,
        type: "spring",
        damping: 10,
      },
    }}
    className="sidebar"
  >
          <div className="top_section">
            <AnimatePresence>
              {isOpen && (
                <motion.h3
                  variants={showAnimation}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="logo"
                >
                  Admin Panel
                </motion.h3>
              )}
            </AnimatePresence>

            <div className="bars">
              <FaBars onClick={toggle} />
            </div>
          </div>
          <div className="search">
            <div className="search_icon">
              <BiSearch />
            </div>
            <AnimatePresence>
              {isOpen && (
                <motion.input
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  variants={inputAnimation}
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              )}
            </AnimatePresence>
          </div>
          <section className="routes">
            {isOpen && searchTerm.trim() && filteredRoutes.length === 0 && (
              <p className="sidebar-no-results">No matching pages.</p>
            )}
            {filteredRoutes.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                    forceOpen={!!searchTerm.trim()}
                    key={index}
                  />
                );
              }

              return (
                <NavLink
                  to={route.path}
                  key={index}
                  end={route.path === "/admin/"}
                  className={({ isActive }) => `link${isActive ? " active" : ""}`}
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })}
          </section>
        </motion.div>

       <main className={`content ${isOpen ? "content-open" : "content-closed"}`}>
    {children}
  </main>
      </div>
    </>
  );
};

export default SideBar;
